import { render, staticRenderFns } from "./popupLayout.vue?vue&type=template&id=06c41011"
import script from "./popupLayout.vue?vue&type=script&lang=js"
export * from "./popupLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports